// extracted by extract-css-chunks-webpack-plugin
module.exports = {"labelContainer":"displayBoxLabel__labelContainer--1XDdo"};